import { render, staticRenderFns } from "./VehiculosGridSugal.vue?vue&type=template&id=651004f7&"
import script from "./VehiculosGridSugal.vue?vue&type=script&lang=ts&"
export * from "./VehiculosGridSugal.vue?vue&type=script&lang=ts&"
import style0 from "./VehiculosGridSugal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports